(function () {
  'use strict';
  const cache = new Map(), pending = new Map(), ttl = 60000;
  const root = document.body.dataset.root || '';
  const valid = s => s && s.kind === 'dd-purchase-state-v1' && typeof s.handle === 'string' && typeof s.comingSoon === 'boolean' && Array.isArray(s.variants);
  function seed(product) {
    if (!product || !product.handle || !Array.isArray(product.variants)) return;
    cache.set(product.handle, {kind: 'dd-purchase-state-v1', handle: product.handle, title: product.title, comingSoon: !!product.comingSoon, variants: product.variants, checkedAt: Date.now()});
  }
  async function resolve(handle, force) {
    if (!handle) return null;
    const previous = cache.get(handle);
    if (!force && previous && Date.now() - previous.checkedAt < ttl) return previous;
    if (pending.has(handle)) return pending.get(handle);
    const request = (async () => {
      try {
        const response = await fetch(root + '/products/' + encodeURIComponent(handle) + '?view=dd-purchase-state', {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000)});
        if (!response.ok) throw new Error('Availability unavailable');
        const state = await response.json();
        if (!valid(state) || state.handle !== handle) throw new Error('Invalid availability response');
        const result = {...state, checkedAt: Date.now()};
        cache.set(handle, result);
        return result;
      } catch (error) {
        cache.set(handle, {...previous, handle, failed: true, checkedAt: 0});
        return null;
      } finally {
        pending.delete(handle);
      }
    })();
    pending.set(handle, request);
    return request;
  }
  function inspect(item) {
    const state = cache.get(item.handle);
    if (!state || state.failed || Date.now() - state.checkedAt >= ttl) return {status: 'checking', failed: !!(state && state.failed), item};
    const variant = state.variants.find(v => String(v.id) === String(item.id));
    const current = {...item, title: state.title || item.title, price: variant ? Number(variant.price) : item.price, mto: !state.comingSoon && !!(variant && variant.mto), comingSoon: state.comingSoon};
    if (state.comingSoon) return {status: 'coming-soon', item: current};
    return {status: variant && variant.available ? 'ready' : 'unavailable', item: current};
  }
  function summary(items) {
    const entries = items.map((item, index) => ({...inspect(item), index}));
    const ready = entries.filter(e => e.status === 'ready').map(e => e.item);
    return {entries, ready, checking: entries.some(e => e.status === 'checking'), failed: entries.some(e => e.failed), comingSoon: entries.some(e => e.status === 'coming-soon'), unavailable: entries.some(e => e.status === 'unavailable'), subtotal: ready.reduce((sum, item) => sum + item.price * item.qty, 0)};
  }
  async function refresh(items, force) {
    await Promise.all([...new Set(items.map(item => item.handle).filter(Boolean))].map(handle => resolve(handle, force)));
    return summary(items);
  }
  window.DDPrelaunch = {seed, summary, refresh};
})();
